import React from 'react';
import styled from 'styled-components';
import { FaFacebookF } from 'react-icons/fa';

const FooterSection = styled.footer`
  background: var(--earth);
  padding: 60px 20px 30px;
`;

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
`;

const Logo = styled.div`
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  color: var(--wheat);
  margin-bottom: 8px;
`;

const Tagline = styled.p`
  font-size: 0.95rem;
  color: rgba(245, 222, 179, 0.5);
  margin-bottom: 25px;
  font-style: italic;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(139, 35, 35, 0.5);
  border: 1px solid rgba(139, 35, 35, 0.8);
  color: var(--wheat);
  border-radius: 50%;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    background: var(--barn-red);
  }

  svg {
    font-size: 1rem;
  }
`;

const Divider = styled.div`
  width: 80px;
  height: 1px;
  background: rgba(245, 222, 179, 0.15);
  margin: 0 auto 20px;
`;

const Copyright = styled.p`
  font-size: 0.85rem;
  color: rgba(245, 222, 179, 0.35);
`;

const Credit = styled.p`
  font-size: 0.8rem;
  color: rgba(245, 222, 179, 0.3);
  margin-top: 10px;

  a {
    color: rgba(245, 222, 179, 0.5);
    transition: color 0.3s ease;

    &:hover {
      color: var(--wheat);
    }
  }
`;

export default function Footer() {
  return (
    <FooterSection>
      <Container>
        <Logo>Red Barn Gardens</Logo>
        <Tagline>Williston, Vermont</Tagline>

        <SocialLinks>
          <SocialLink
            href="https://www.facebook.com/RedBarnGardens"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </SocialLink>
        </SocialLinks>

        <Divider />

        <Copyright>
          &copy; {new Date().getFullYear()} Red Barn Gardens. All rights reserved.
        </Copyright>
        <Credit>
          Website created by <a href="https://forgewell.live" target="_blank" rel="noopener noreferrer">Forgewell</a>
        </Credit>
      </Container>
    </FooterSection>
  );
}
